const padding = {
    name: "padding",
    path: "/padding",
    title: "Padding",
    description: "Utilities for controlling the padding of elements.",
     value: {
        "padding": {
            "p-<number>": "calc(var(--1) * <number>)",
            "p-<fraction>": "<fraction>) * 100%",
            "p-px": "1px",
            "p-[<value>]": "<value>",
        },
        "padding-inline": {
            "px-<number>": "calc(var(--1) * <number>)",
            "px-<fraction>": "<fraction>) * 100%",  
            "px-px": "1px",
            "px-[<value>]": "<value>",
        },
        "padding-block": {
            "py-<number>": "calc(var(--1) * <number>)",
            "py-<fraction>": "<fraction>) * 100%",  
            "py-px": "1px",
            "py-[<value>]": "<value>",
        },
        "padding-top": {
            "pt-<number>": "calc(var(--1) * <number>)",
            "pt-<fraction>": "<fraction>) * 100%",
            "pt-px": "1px",
            "pt-[<value>]": "<value>",
        },
        "padding-right": {
            "pr-<number>": "calc(var(--1) * <number>)",
            "pr-<fraction>": "<fraction>) * 100%",  
            "pr-px": "1px",
            "pr-[<value>]": "<value>",
        },
        "padding-bottom": {
            "pb-<number>": "calc(var(--1) * <number>)",
            "pb-<fraction>": "<fraction>) * 100%",
            "pb-px": "1px",
            "pb-[<value>]": "<value>",
        },
        "padding-left": {
            "pl-<number>": "calc(var(--1) * <number>)",
            "pl-<fraction>": "<fraction>) * 100%",
            "pl-px": "1px",
            "pl-[<value>]": "<value>",
        },
    },

        exampleData: [
        {
            "example": {
                "code": `
<div class="p-8 ...">p-8</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="pt-6 ...">pt-6</div>
<div class="pr-4 ...">pr-4</div>
<div class="pb-8 ...">pb-8</div>
<div class="pl-2 ...">pl-2</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="px-8 ...">px-8</div>
<div class="py-8 ...">py-8</div>
                `
            },
        },
    ],

    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
                Use <code class="text-color-gray-800 dark:text-color-white font-semibold">p-&lt;number&gt;</code>
                utilities like <code>p-4</code> and <code>p-8</code> to control the padding on all sides of an element:
            </p>
            <div class="bg-color-blue-300 w-fit mx-auto rounded-lg">
                <div class="rounded-lg p-8 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700">
                    <div class="bg-color-violet-500 text-color-white flex justify-center items-center rounded-lg p-4 size-16">p-8</div>
                </div>
            </div>
            
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
                Use <code class="text-color-gray-800 dark:text-color-white font-semibold">pt-&lt;number&gt; , pr-&lt;number&gt;, pb-&lt;number&gt;, pl-&lt;number&gt; </code>
                utilities like pt-6 and pr-4 to control the padding on one side of an element:
            </p>
            <div class="grid md:grid-columns-4 gap-6 items-center">
                <div class="bg-color-blue-300 w-fit mx-auto rounded-lg">
                    <div class="rounded-lg pt-6 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700">
                        <div class="bg-color-violet-500 text-color-white flex justify-center items-center rounded-lg p-4 size-20">pt-6</div>
                    </div>
                </div>
                <div class="bg-color-blue-300 w-fit mx-auto rounded-lg">
                    <div class="rounded-lg pr-4 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700">
                        <div class="bg-color-violet-500 text-color-white flex justify-center items-center rounded-lg p-4 size-20">pr-4</div>
                    </div>
                </div>
                <div class="bg-color-blue-300 w-fit mx-auto rounded-lg">
                    <div class="rounded-lg pb-8 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700">
                        <div class="bg-color-violet-500 text-color-white flex justify-center items-center rounded-lg p-4 size-20">pb-8</div>
                    </div>
                </div>
                <div class="bg-color-blue-300 w-fit mx-auto rounded-lg">
                    <div class="rounded-lg pl-2 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700">
                        <div class="bg-color-violet-500 text-color-white flex justify-center items-center rounded-lg p-4 size-20">pl-2</div>
                    </div>
                </div>
            </div>
            
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
                Use <code class="text-color-gray-800 dark:text-color-white font-semibold">px-&lt;number&gt; , py-&lt;number&gt;</code>
                to control the horizontal and vertical  padding of an element:
            </p>
            <div class="flex gap-6 items-center">
                <div class="bg-color-blue-300 w-fit mx-auto rounded-lg">
                    <div class="rounded-lg px-8 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700">
                        <div class="bg-color-violet-500 text-color-white flex justify-center items-center rounded-lg p-4 size-20">px-8</div>
                    </div>
                </div>
                <div class="bg-color-blue-300 w-fit mx-auto rounded-lg">
                    <div class="rounded-lg py-8 bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700">
                        <div class="bg-color-violet-500 text-color-white flex justify-center items-center rounded-lg p-4 size-20">py-8</div>
                    </div>
                </div>
            </div>
            
            `
        }
    ]
};
export default padding;

<div class="bg-color-blue-300 sr-only pt-6 pr-4 pb-8 pl-2 size-20 px-8 py-8"></div>